import { NavLink } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'

const navStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 2rem',
  height: '60px',
  background: '#fff',
  borderBottom: '1px solid #e5e7eb',
  fontFamily: 'system-ui, sans-serif',
}

const brandStyle: React.CSSProperties = {
  fontWeight: 700,
  fontSize: '1.1rem',
  color: '#1e3a5f',
  textDecoration: 'none',
}

const tabsStyle: React.CSSProperties = {
  display: 'flex',
  gap: '0.25rem',
}

function navLinkStyle(isActive: boolean): React.CSSProperties {
  return {
    padding: '0.4rem 1rem',
    borderRadius: '0.375rem',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 500,
    color: isActive ? '#1d4ed8' : '#6b7280',
    background: isActive ? '#eff6ff' : 'transparent',
    transition: 'background 0.15s, color 0.15s',
  }
}

const rightStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
}

const emailStyle: React.CSSProperties = {
  fontSize: '0.85rem',
  color: '#6b7280',
}

const signOutStyle: React.CSSProperties = {
  fontSize: '0.85rem',
  padding: '0.35rem 0.9rem',
  borderRadius: '0.375rem',
  border: '1px solid #d1d5db',
  background: '#fff',
  color: '#374151',
  cursor: 'pointer',
}

export default function NavBar({ inboxCount }: { inboxCount?: number }) {
  const { user, logout } = useAuth()

  return (
    <nav style={navStyle}>
      <span style={brandStyle}>MortgageFlow</span>

      <div style={tabsStyle}>
        <NavLink to="/inbox" style={({ isActive }) => navLinkStyle(isActive)}>
          Inbox
          {inboxCount != null && inboxCount > 0 && (
            <span style={{
              marginLeft: '0.4rem',
              background: '#1d4ed8',
              color: '#fff',
              borderRadius: '9999px',
              fontSize: '0.7rem',
              padding: '0.1rem 0.45rem',
              verticalAlign: 'middle',
            }}>
              {inboxCount}
            </span>
          )}
        </NavLink>
        <NavLink to="/clients" style={({ isActive }) => navLinkStyle(isActive)}>
          Clients
        </NavLink>
      </div>

      <div style={rightStyle}>
        <span style={emailStyle}>{user?.profile.email}</span>
        <button style={signOutStyle} onClick={logout}>Sign out</button>
      </div>
    </nav>
  )
}
